import { resolverEstatusEmpleado } from '../../utils/estatusEmpleado';

// Búsqueda de Empleados Mobile (M.2A). Todo local sobre la lista que App.jsx
// ya mantiene (api/empleados): sin peticiones por tecla. La pantalla es
// operativa: sólo trabaja con empleados ACTIVOS (M.2A.1).

// Minúsculas y sin acentos/diacríticos: "Rodríguez" -> "rodriguez".
export function normalizarTexto(valor) {
  return String(valor == null ? '' : valor)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();
}

// El id puede llegar como texto ("03473") o como número (3473) según la celda.
function idComoTexto(empleado) {
  return String(empleado.id == null ? '' : empleado.id).trim();
}

function sinCerosIniciales(texto) {
  return texto.replace(/^0+(?=\d)/, '');
}

// Activo = mismo criterio que el badge de Desktop (helper compartido).
export function esActivo(empleado) {
  return resolverEstatusEmpleado(null, empleado).tipo === 'activo';
}

// Rango de coincidencia (menor = más relevante) o null si no coincide.
//   0: número de empleado exacto
//   1: mismo número sin considerar ceros iniciales ("3473" -> "03473")
//   2: el nombre empieza con el texto buscado
//   3: cada palabra buscada inicia alguna palabra del nombre
//   4: resto (subcadenas en nombre o en número)
function rangoCoincidencia(empleado, consulta, palabras) {
  const id = normalizarTexto(idComoTexto(empleado));
  const soloDigitos = /^\d+$/.test(consulta);

  if (id) {
    if (id === consulta) return 0;
    if (soloDigitos && /^\d+$/.test(id) && sinCerosIniciales(id) === sinCerosIniciales(consulta)) return 1;
  }

  const nombre = normalizarTexto(empleado.nombre);
  if (nombre && palabras.every(p => nombre.includes(p))) {
    if (nombre.startsWith(consulta)) return 2;
    const palabrasNombre = nombre.split(/\s+/);
    if (palabras.every(p => palabrasNombre.some(w => w.startsWith(p)))) return 3;
    return 4;
  }

  if (id && (id.includes(consulta) || (soloDigitos && sinCerosIniciales(id).includes(sinCerosIniciales(consulta))))) return 4;
  return null;
}

function compararPorNombre(a, b) {
  return String(a.nombre || '').localeCompare(String(b.nombre || ''), 'es', { sensitivity: 'base' });
}

// Aplica búsqueda (y orden por relevancia) a una lista ya filtrada.
export function buscarEmpleados(empleados, texto) {
  const consulta = normalizarTexto(texto).replace(/\s+/g, ' ');
  if (!consulta) return [...empleados].sort(compararPorNombre);
  const palabras = consulta.split(' ');
  return empleados
    .map(e => ({ e, rango: rangoCoincidencia(e, consulta, palabras) }))
    .filter(r => r.rango !== null)
    .sort((a, b) => a.rango - b.rango || compararPorNombre(a.e, b.e))
    .map(r => r.e);
}

// Activos que coinciden con la búsqueda + total de activos (para el contador).
export function resultadosEmpleados(empleados, texto) {
  const activos = (empleados || []).filter(esActivo);
  return { lista: buscarEmpleados(activos, texto), totalActivos: activos.length };
}

// Selección por ID (nunca por objeto): tolera que el refresh periódico de
// App reemplace el arreglo y que el id cambie de número a texto.
export function buscarPorId(empleados, id) {
  if (id == null) return null;
  const buscado = String(id).trim();
  return (empleados || []).find(e => idComoTexto(e) === buscado) || null;
}
